"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateAdminInitialValues = void 0;
exports.CreateAdminInitialValues = {
    username: '',
    email: '',
};
//# sourceMappingURL=AdminGeneral.js.map